export const LOADING_DESIGNATION = "LOADING_DESIGNATION";
export const GET_DESIGNATION_LIST = "GET_DESIGNATION_LIST";
export const GET_DESIGNATIONBYID = "GET_DESIGNATIONBYID";
export const REMOVE_DESIGNATION = "REMOVE_DESIGNATION";
export const ADD_DESIGNATION = "ADD_DESIGNATION";
export const UPDATE_DESIGNATION = "UPDATE_DESIGNATION";